module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-07-12554b772a07d5111a4a61810d3bb206.jpg";